module.exports = __webpack_public_path__ + "media/gcc_introductions/bg_conversion-4e8fa923.png";